<template>
  <div class="pa-3 pa-sm-4 pa-md-5">
    <div class="d-flex align-center mb-4 mb-sm-5">
      <v-btn @click="$router.back()" class="back-btn">
        <v-icon left>mdi-arrow-left</v-icon>
        VOLVER
      </v-btn>
    </div>
    <v-col cols="12" class="pa-0">
      <tabla
        Titulo="Gestión de Usuarios"
        :Cabecera="Cabecera"
        :Items="Items"
        :Excel="true"
        :Crear="true"
        :Loading="Loading"
      />
    </v-col>
  </div>
</template>

<script>
import tabla from "@/components/usuario/tabla.vue";

import { mapGetters, mapActions, mapState } from "vuex";
export default {
  components: {
    tabla,
  },

  created() {
    this.cargarUsuario();
  },
  data() {
    return {
      Cabecera: [
        {
          text: "Acción",
          value: "accion",
          align: "center",
          sortable: false,
          width: 100,
        },
        {
          text: "Código",
          value: "id",
          align: "center",
          width: 80,
        },
        {
          text: "Rol",
          value: "rol",
          align: "center",
          width: 140,
        },
        {
          text: "Nombre y Apellidos",
          value: "name",
          align: "left",
        },
        {
          text: "Email",
          value: "email",
          align: "left",
        },
        {
          text: "Firma",
          value: "img_firma",
          align: "center",
          width: 100,
        },
        {
          text: "Fecha Registro",
          value: "fecha",
          align: "center",
          width: 130,
        },
      ],
    };
  },
  methods: {
    ...mapActions("usuario", ["cargarUsuario"]),
  },

  computed: {
    ...mapGetters("usuario", ["Items"]),
    ...mapState("usuario", ["Loading"]),
  },
};
</script>

<style scoped>
.back-btn {
  font-weight: 700;
  letter-spacing: 0.3px;
  border-radius: 8px;
  text-transform: none;
  transition: all 0.2s ease;
}

.back-btn:hover {
  transform: translateX(-2px);
}
</style>
